import { sportClubService } from '@/services/api/sportClub.service';
import { sportClubModel } from '@/models/api/sportClub.model';
import { alertHelper, sharedHelper } from '@/utils';
import i18n from '@/i18n';

export const SPORT_CLUB_MODULE = 'api/sportClub';
export const GET_ALL_SPORT_CLUB = 'getAllSportClub';
export const GET_SPORT_CLUB = 'getSportClub';
export const CREATE_SPORT_CLUB = 'createSportClub';
export const UPDATE_SPORT_CLUB = 'updateSportClub';
export const UPDATE_SPORT_CLUB_STATUS = 'updateSportClubStatus';
export const LOAD_SPORT_CLUB_OPTIONS = 'loadSportClubOptions';

export const state = {
    list: { data: [], pagination: { pageNumber: 1, pageSize: 10, total: 0 } },
    details: null,
    status: { list: true, detail: true, save: true, options: true },
    errors: { list: '', detail: '', save: '', options: '' },
    options: { sportTypes: [], boardTypes: [], users: [] },
    listRequest: 0,
};

export const actions = {
    async [LOAD_SPORT_CLUB_OPTIONS]({ commit }) {
        commit('requesting', 'options');
        try {
            const options = await sportClubService.getOptions();
            commit('optionsLoaded', options);
            return options;
        } catch (error) {
            commit('failed', { type: 'options', error: sharedHelper.getErrorMessage(error) });
            return null;
        } finally {
            commit('finished', 'options');
        }
    },
    async [GET_ALL_SPORT_CLUB]({ commit, state }, { filter } = {}) {
        commit('requesting', 'list');
        const request = state.listRequest;
        try {
            const response = await sportClubService.getAll(filter);
            if (request === state.listRequest) commit('listed', response);
            return response?.data || response;
        } catch (error) {
            if (request === state.listRequest) commit('failed', { type: 'list', error: sharedHelper.getErrorMessage(error) });
            return null;
        } finally {
            if (request === state.listRequest) commit('finished', 'list');
        }
    },
    async [GET_SPORT_CLUB]({ commit }, { uuid }) {
        commit('requesting', 'detail');
        try {
            const response = await sportClubService.show(uuid);
            const result = response?.data || response;
            commit('detailed', result);
            return result;
        } catch (error) {
            commit('failed', { type: 'detail', error: sharedHelper.getErrorMessage(error) });
            return null;
        } finally {
            commit('finished', 'detail');
        }
    },
    async [CREATE_SPORT_CLUB]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const response = await sportClubService.store(data);
            const result = response?.data || response;
            alertHelper.alertSuccess({ message: i18n.t('sports.created') });
            await dispatch(GET_ALL_SPORT_CLUB, { filter });
            return result;
        } catch (error) {
            const msg = sharedHelper.getErrorMessage(error);
            alertHelper.alertError({ message: msg, title: i18n.t('message.error') });
            commit('failed', { type: 'save', error: msg });
            return null;
        } finally {
            commit('finished', 'save');
        }
    },
    async [UPDATE_SPORT_CLUB]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const response = await sportClubService.update(data);
            const result = response?.data || response;
            alertHelper.alertSuccess({ message: i18n.t('sports.updated') });
            await dispatch(GET_ALL_SPORT_CLUB, { filter });
            return result;
        } catch (error) {
            const msg = sharedHelper.getErrorMessage(error);
            alertHelper.alertError({ message: msg, title: i18n.t('message.error') });
            commit('failed', { type: 'save', error: msg });
            return null;
        } finally {
            commit('finished', 'save');
        }
    },
    async [UPDATE_SPORT_CLUB_STATUS]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const response = await sportClubService.updateStatus(data);
            const result = response?.data || response;
            alertHelper.alertSuccess({ message: i18n.t('sports.statusUpdated') });
            await dispatch(GET_ALL_SPORT_CLUB, { filter });
            return result;
        } catch (error) {
            const msg = sharedHelper.getErrorMessage(error);
            alertHelper.alertError({ message: msg, title: i18n.t('message.error') });
            commit('failed', { type: 'save', error: msg });
            return null;
        } finally {
            commit('finished', 'save');
        }
    },
};

export const mutations = {
    optionsLoaded(state, options) {
        state.options = options || { sportTypes: [], boardTypes: [], users: [] };
    },
    requesting(state, type) {
        state.status[type] = false;
        state.errors[type] = '';
        if (type === 'list') state.listRequest++;
        if (type === 'detail') state.details = null;
    },
    finished(state, type) { state.status[type] = true; },
    failed(state, { type, error }) { state.errors[type] = error; },
    clearSaveError(state) { state.errors.save = ''; },
    listed(state, result) {
        const list = Array.isArray(result)
            ? result
            : (Array.isArray(result?.data) ? result.data : []);
        state.list.data = list.map(sportClubModel);
        const pagination = (!Array.isArray(result) && result?.pagination) ? result.pagination : {};
        state.list.pagination = sharedHelper.apiPaginationAdapter(pagination);
    },
    detailed(state, result) {
        const detail = (result && result.data && !result.uuid) ? result.data : result;
        state.details = detail ? sportClubModel(detail) : null;
    },
};
